"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function useSSR() {
  var _react_1$useState = react_1.useState(canUseDOM),
      inBrowser = _react_1$useState[0],
      setInBrowser = _react_1$useState[1];

  react_1.useEffect(function () {
    setInBrowser(canUseDOM);
    return function () {
      setInBrowser(false);
    };
  }, []);
  var useSSRObject = react_1.useMemo(function () {
    return {
      isBrowser: inBrowser,
      isServer: !inBrowser,
      canUseWorkers: typeof Worker !== 'undefined',
      canUseEventListeners: inBrowser && !!window.addEventListener,
      canUseViewport: inBrowser && !!window.screen
    };
  }, [inBrowser]);
  return react_1.useMemo(function () {
    return Object.assign(Object.values(useSSRObject), useSSRObject);
  }, [inBrowser]);
}

exports.default = useSSR;